import React from 'react';
import { PropTypes } from 'prop-types';
import LocationMapError from './LocationMapError';

class MapErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// You can log the error to an error reporting service here
		// eslint-disable-next-line no-console
		console.error('MapErrorBoundary caught an error:', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// Fallback UI when map fails
			return <LocationMapError mapUrl={this.props.mapUrl} />;
		}

		return this.props.children;
	}
}

MapErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired,
	mapUrl: PropTypes.string.isRequired
};

export default MapErrorBoundary;
